import { fetchWrapper } from "../Helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}/ds-reports`;

export const reportService = {
  getAll,
  updateStatus,
  saveReport,
  getReport,
  updateReport,
  getTokenData,
  getReportStats,
  getCampaignReportStats,
  getOfferReportStats
};
function getAllPaging(options, filterString) {
  filterString += filterString.length > 0 ? `&` : "";
  filterString += `page[number]=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : "";
    filterString += `page[size]=${options.pageSize}`;
  }
  return filterString;
}
function getAll(options) {
  let filterString = "";
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrl}?${filterString}` : `${baseUrl}`;
  return fetchWrapper.get(url);
}

function updateStatus(reportId, status) {
  return fetchWrapper.put(`${baseUrl}/${reportId}/status`, { 'status': status });

}
function saveReport(param) {
  return fetchWrapper.post(`${baseUrl}`, param);
}
function updateReport(param, id) {
  return fetchWrapper.put(`${baseUrl}/${id}`, param);
}
function getReport(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}
function getTokenData() {
  //debugger
  return fetchWrapper.get(`${baseUrl}` + "/token-data");
}
function getReportStats(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/stats`);
}
function getCampaignReportStats(id) {
  return fetchWrapper.get(`${process.env.REACT_APP_API_URL}/ds-campaigns/${id}/report/stats`);
}
function getOfferReportStats(id) {
  return fetchWrapper.get(`${process.env.REACT_APP_API_URL}/offers/${id}/report/stats`);
}